import React from 'react';

import classes from '../installPics.css';

import PRoofImg5 from '../../../../../../../assets/PitchedRoofImg5.jpg';

const PitchedRoofImg5 = () => (
    <div className={classes.installImages}>
        <img alt="A 15kW Array in Central New Jersey" src={PRoofImg5} className={classes.installImg} />
    </div>
);


export default PitchedRoofImg5;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/PitchedRoofImages/PitchedRoofImg5.js